import moment from "moment";

export function formatLocalDate(momentInstance, format = "DD/MM/YYYY") {
  if (!moment.isMoment(momentInstance)) {
    throw new Error("Se esperaba una instancia de moment");
  }

  return momentInstance.local().format(format);
}
